import orderBy from 'lodash.orderby';

export default ({ collection = [], searchKeys = [], searchText }) => {
  // If there are no search keys we return the full collection immediately
  // As we have no keys to search against
  if (searchKeys.length === 0) return collection;
  // If there is no search text than return the full collection immediately
  if (searchText.length === 0) return collection;
  /*
    We ingest a string that is given by the user to create a series of regex patterns.
    To do this we split on a single space char to create our array, then we filter out
    any empty strings, which get created when you initially add a space with no characters
    in the next word. Then we create a regex with the gi flags.
    The replace line is there to escape any problematic search queries
   */

  const searchPatterns = searchText
    .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    .split(' ')
    .filter(i => i.length > 0)
    .map(i => new RegExp(i, 'gi'));
  /*
      We search through the collection by iterating throuch each element in the collection.
      Then iterate through each key that got passed into our search function, testing the
      value for that key in the dataPoint against our regex pattern.
      When we find a match we increment the search weight which we can later use to sort.
      I have named this search weight attribute with two leading under scores and a namespace
      of search to be confident in any clashing of keys.
     */
  const searchedCollection = collection.map((dataPoint = {}) => {
    let __searchWeight = 0;
    searchKeys.forEach(key => {
      const { [key]: textToSearch = '' } = dataPoint || {};
      searchPatterns.forEach(searchPattern => {
        if (searchPattern.test(textToSearch)) __searchWeight += 1;
      });
    });
    return { ...dataPoint, __searchWeight };
  });
  /*
    We then filter out any dataPoints that did not have any matches.
   */
  const filteredCollection = searchedCollection.filter(
    dataPoint => dataPoint.__searchWeight > 0,
  );

  /*
    JS .sort is not stable across browsers and so we use lodash orderBy
    to sort our new collection by search weight.
   */
  const sortedCollection = orderBy(
    filteredCollection,
    '__searchWeight',
    'desc',
  );

  return sortedCollection;
};
